// Copyright (c) 2025. UpCircle Technology AG.
// All rights reserved. Redistribution in source and/or binary forms,
// with or without modification, is not permitted.

export default {
  translation: {
    general_cancel: 'Cancel',
    general_delete: 'Delete',
    general_save: 'Save',
    general_back: 'Back',
    general_okay: 'Okay',
    general_loading: 'Loading',
    general_close: 'Close',
    general_add: 'Add',
    general_yes: 'Yes',
    general_no: 'No',

    login: 'Sign in',
    login_wrong_credentials: 'Wrong username or password',
    auth_or: 'or',
    auth_sign_in_google: 'Sign in with Google',
    auth_sign_in_microsoft: 'Sign in with Microsoft',
    auth_no_account: 'No account found. Please contact your administrator.',
    auth_popup_blocked: 'Pop-up was blocked by the browser. Please allow pop-ups and try again.',
    auth_network_error: 'Network error. Please check your connection and try again.',
    auth_link_existing_account:
      'An account already exists with this email. Please sign in with your password to link accounts.',
    auth_link_email_mismatch:
      'Please sign in with the same email used in the social popup to complete account linking.',
    auth_link_failed: 'We could not link your social sign-in. Please try again.',
    auth_email: 'Email',
    auth_password: 'Password',

    navbar_hello: 'Hi',

    deliveries_title: 'Deliveries',
    deliveries_bale_feed_title: 'Bale Feed',
    deliveries_loading: 'loading',
    deliveries_new: 'New Delivery',

    delivery: 'Delivery',
    delivery_images_delivery: 'Delivery Images',
    delivery_images_bales: 'Bale Images',
    delivery_bales_detected: 'Bales detected',
    delivery_confirm_complete: 'Delivery complete?',
    delivery_confirm_complete_info: 'Confirm input and mark delivery as complete?',
    delivery_confirm_delete: 'Delete delivery?',
    delivery_confirm_delete_info:
      'This action cannot be undone. This will permanently delete the delivery and all associated data.',
    delivery_import: 'Update Delivery',
    delivery_import_success: 'Bales successfully imported into delivery!',
    delivery_confirm_delete_image: 'Delete image?',
    delivery_confirm_delete_image_description:
      'This action cannot be undone. This will permanently delete the image and all associated data.',
    delivery_confirm_delete_image_info: 'All associated bales will be removed as well.',
    delivery_bale_detection_no_bales_detected: 'No bales were detected.',
    delivery_bale_detection_error:
      'An error occurred during bale detection. No worries, try again or keep taking photos of the delivery.',
    delivery_recompute_detection: 'Try Again',
    complete_delivery_save_draft: 'Save Draft',
    complete_delivery_complete: 'Mark as complete',

    // Image Quality Warnings
    image_quality_warning_short: 'All warnings resolved.',
    affected_images_skipped: 'Status: affected images skipped',
    image_quality_warning: 'Image Quality Warning',
    quality_issues_suggestion: 'Please retake the photo or proceed without analysis.',
    bales_selected_with_issues: '{{count}} of {{total}} bales selected with issues',
    analysis_ready: 'Analysis Ready',
    image_not_analyzed: 'Image Not Analyzed',

    // AI Analysis Section
    ai_analysis: 'AI Analysis',
    no_ai_analysis_available: 'There is no AI analysis available for the delivery.',
    no_data: 'no data',
    company_benchmark: '{{company}} Benchmark',
    industry_benchmark: 'Industry Benchmark for',
    outliers: 'outliers',
    bales_analyzed: 'Bales Analyzed',
    issues: 'issues',
    problem_delivery_photos: 'PROBLEM DELIVERY PHOTOS',
    problem_bales: 'PROBLEM BALES',
    see_more: 'see more',
    show_less: 'show less',
    contaminants: 'contaminants',
    no_contamination: 'Great News!',
    total: 'total',
    brown_paper_content: 'Brown Paper Content',
    no_contamination_detected_message: 'No contamination or anomalies detected in this batch',
    no_issues: 'no issues',
    no_image_errors_detected: 'All selected images analyzed. No processing errors found.',
    type_detected: 'contamination type detected',
    types_detected: 'contamination types detected',
    no_bales_analyzed_brown_content_message:
      'No bales analyzed for brown paper content. Poor quality or laminate side bales. Please retake the photos to see analysis',
    no_historical_data_supplier_benchmarks_message:
      'No historical data available for supplier benchmarks. More deliveries needed to calculate industry and supplier averages',
    material_match: 'Material Match',
    expected: 'Expected',
    material_mismatch_breakdown: 'Mismatch Breakdown',
    material_mismatch_breakdown_description: 'Bales with material mismatches per category',
    material_mismatch_complete_match_message: 'All bales match the material category of the delivery',
    match: 'Match',
    mismatch: 'Mismatch',
    mismatch_rate: 'Mismatch Rate',
    mismatch_analysis_summary_tooltip:
      'Total analyzed bales: {{analyzed}}\nMatches with delivery material: {{matchCount}} ({{matchPercentage}}%)\n{{mismatchCount}} bales deviate from the material of the delivery.\n',

    claim: 'Claim',
    claim_photos: 'Claim Photos',
    claim_linked_bales: 'Linked Bales & Photos',
    claim_confirm: 'Confirm & Submit',
    claim_send_confirm_title: 'Do you want to notify about the claim?',
    claim_send_warning: 'Notification already sent!',
    claim_send: 'Notify',
    claim_send_confirmation: 'Notification successfully sent!',
    claim_not_sent_confirmation: 'Claim saved. No emails were sent.',
    claim_notes: 'Notes',
    claim_notes_placeholder: 'Additional details about the claim...',

    scanned_document_extraction_success: 'Information successfully extracted.',
    scanned_document_extraction_running: 'Extracting information...',
    scanned_document_extraction_error: 'Extraction failed. Try again.',
    scanned_document_extraction_info: 'Take a picture of the weighing slip to automatically extract information.',
    scanned_document_take_picture: 'Take Picture',

    instructions_import_bales: 'Instructions: Import Bales',
    instructions_scan_truck: 'Instructions: Scan Truck',

    labeling_panel_toggle: 'Labeling Panel',
    labeling_title: 'Labeling',

    property_field_extendable_new: 'New entry?',
    property_notes: 'NOTES',
    property_supplier: 'SUPPLIER',
    property_storage_field: 'STORAGE FIELD',
    property_date: 'DATE',
    property_submitted_by: 'SUBMITTED BY',
    property_problems: 'PROBLEM POINTS',
    property_material: 'MATERIAL',
    property_material_group: 'MATERIAL GROUP',
    property_document_scanner: 'DOCUMENT SCANNER',
    material_properties: 'Material Properties',
    property_supplier_no: 'SUPPLIER NO',
    property_supplier_name: 'SUPPLIER NAME',
    property_order_no: 'ORDER NO',
    property_license_plate: 'LICENSE PLATE TRUCK',
    property_weight_first: '1. WEIGHING',
    property_weight_second: '2. WEIGHING',
    property_weight_netto_1: 'NETTO I',
    property_weight_netto_2: 'NETTO II',
    property_doc_type: 'DOCUMENT TYPE',
    property_slip_nr: 'DOCUMENT NR',

    delivery_documents_scanned: 'Documents',
    document_type_weighing_slip: 'Weighing Slip',
    document_type_delivery_slip: 'Delivery Slip',

    bale_feed_no_data: 'No data',
    bale: 'bale',
    bales: 'bales',
    material: 'Material',

    // Shared Components
    labeling_select_recommended: 'Recommended',
    labeling_select_others: 'Others',
    labeling_request: 'Labeling request',
    labeling_skip: 'Skip label',
    labeling_no_more_requests: 'No more labeling requests found.',
    license_agreement_title: 'License Agreement',
    license_agreement_decline: 'Decline',
    license_agreement_accept: 'Accept',

    access_denied_back_to_login: 'Back to Login',
    access_denied_contact_admin: 'Contact Administrator',
    access_denied_support_email: 'support@upcircle.com',
    access_denied_copyright: 'UpCircle © 2025',
    access_denied_title: 'Access Denied',
    access_denied_message:
      'This application requires initial setup by your system administrator before it can be accessed.',
  },
};
